import TypeToReducer from 'type-to-reducer';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

import {
  ADD_ASSET,
  ADD_ASSETS_FILES,
  CALCULATE_ASSET_DEPRECIATION,
  GET_ASSET_BY_ID,
  MODIFY_CUSTOM_FIELD_EDITING_ASSET, //Groups
  GET_ASSETS_FORM_CONFIG,
  GET_ASSETS_DISABLE_FORM_CONFIG,
  MODIFY_ASSET,
  NEW_ASSET,
  PROGRESS_ASSETS_FILE,
  REMOVE_ASSETS_FILE,
  RESET_ASSETS_FORM,
  SET_ASSETS_IS_SAVING,
  UPLOAD_ASSETS_FILE,
  REMOVE_ASSETS_UPLOADED_FILE,
  ADD_ASSET_NOTE,
  REMOVE_ASSET_NOTE,
  MODIFY_ASSET_NOTE,
  MODIFY_FILE,
  OUTPUT_ASSET,
  INPUT_ASSET,
  ACEPT_OUTPUT,
  REJECT_OUTPUT,
} from 'containers/assets/constants';

export const initialState = {
  asset: { _files: [], _notes: [], _custom: [], _group: [] },
  uploadFiles: {},
  uploadFilesIds: [],
  isSaving: false,
  isLoading: false,
  isFetching: false,
};

export const parseSublocations = (state, { payload }) => {
  const sublocationProps = Object.keys(payload)
    .sort()
    .map((p) => /^sublocation\[(\d+)\]$/gi.exec(p))
    .filter((p) => p)
    .map((p) => [p[0], parseInt(p[1], 10)]);

  if (sublocationProps.length) {
    let location = payload.location ? payload.location : state.asset.location || '';

    delete payload.location;

    let parentLocations = location.split('.').filter((p) => !!p);

    sublocationProps.forEach(([prop, index]) => {
      parentLocations = [...parentLocations.slice(0, index), payload[prop]];
      delete payload[prop];
    });

    location = parentLocations.join('.');
    payload = { ...payload, location };
  }
  return payload;
};

export const modifyAsset = (state, { payload }) => {
  payload = parseSublocations(state, { payload });

  Object.keys(payload).forEach((key) => {
    if (payload[key] === null) {
      delete state.asset[key];
      delete payload[key];
    }
  });

  return {
    ...state,
    asset: { ...state.asset, ...payload },
  };
};

export const getPending = (state) => ({ ...state, isLoading: true });
export const getRejected = (state) => ({ ...state, isLoading: false });
export const getFulfilled = (state) => ({ ...state, isLoading: false });

export const getByIdPending = (state) => ({ ...state, isFetching: true });
export const getByIdRejected = (state) => ({ ...state, isFetching: false });
export const getByIdFulfilled = (state, { payload: { asset } }) => ({
  ...state,
  isFetching: false,
  uploadFiles: {},
  uploadFilesIds: [],
  asset: { ...{ _files: [], _notes: [] }, ...asset },
});

export const newAsset = (state) => ({ ...initialState });
export const resetForm = (state) => ({ ...initialState });

export const calculateDepreciation = (
  { asset },
  {
    payload: { _financialDepreciationResult, _fiscalDepreciationResult, _extraDepreciationsResult },
  }
) => ({
  asset: {
    ...asset,
    _financialDepreciationResult,
    _fiscalDepreciationResult,
    _extraDepreciationsResult: [..._extraDepreciationsResult],
  },
});
// TODO: nunca entra al payload null, debido a que antes de eso usa destructuring lo que daria en un error.
export const addAssetsFiles = (state, { payload }) =>
  (payload && {
    ...state,
    uploadFiles: {
      ...state.uploadFiles,
      ...payload.reduce((re, f) => ({ ...re, [f.id]: f }), {}),
    },
    uploadFilesIds: [...state.uploadFilesIds, ...payload.map((f) => f.id)],
  }) ||
  state;

export const removeAssetsFile = (state, { payload }) => {
  console.log('%c ' + 'Entro normal', 'background: #222; color: #bada55');
  console.log('%c ' + JSON.stringify(payload), 'background: #222; color: #bada55');

  const uploadFilesIds = state.uploadFilesIds.filter((id) => id !== payload.id);
  const uploadFiles = uploadFilesIds.reduce(
    (re, id) => ({ ...re, [id]: state.uploadFiles[id] }),
    {}
  );
  return { ...state, uploadFilesIds, uploadFiles };
};

export const progressAssetsFile = (state, { payload }) => ({
  ...state,
  uploadFiles: {
    ...state.uploadFiles,
    [payload.id]: {
      ...state.uploadFiles[payload.id],
      percentage: payload.percentage,
    },
  },
});

export const uploadFilePending = (state, { payload, meta }) => ({
  ...state,
  uploadFiles: {
    ...state.uploadFiles,
    [meta.id]: {
      ...state.uploadFiles[meta.id],
      status: 'files.uploading',
    },
  },
});

export const uploadFileRejected = (state, { payload, meta }) => ({
  ...state,
  uploadFiles: {
    ...state.uploadFiles,
    [meta.id]: {
      ...state.uploadFiles[meta.id],
      status: 'files.fail',
    },
  },
});

export const uploadFileFulfilled = (state, { payload, meta }) => {
  const [file] = payload.files;
  return {
    ...state,
    uploadFiles: {
      ...state.uploadFiles,
      [meta.id]: {
        ...state.uploadFiles[meta.id],
        status: 'files.uploaded',
      },
    },
    asset: {
      ...state.asset,
      _files: [
        ...(state.asset._files || []),
        {
          originalName: file.originalFileName,
          name: file.originalFileName,
          url: file.url,
          default: false,
        },
      ],
    },
  };
};

export const setIsSaving = (state, { payload }) => ({
  ...state,
  isSaving: payload,
});

export const addPending = (state) => ({ ...state, isSaving: true });
export const addRejected = (state) => ({ ...state, isSaving: false });
export const addFulfilled = (state) => ({ ...state, isSaving: false });

export const in_outPending = (state) => ({ ...state, isSaving: true });
export const in_outRejected = (state) => ({ ...state, isSaving: false });
export const in_outFulfilled = (state) => ({ ...state, isSaving: false });

export const removeAssetsUploadedFile = (state, { payload }) => ({
  ...state,
  asset: {
    ...state.asset,
    _files: [...state.asset._files.filter((f) => f.id !== payload)],
  },
});

export const addAssetNote = (state, { payload }) => ({
  ...state,
  asset: { ...state.asset, _notes: [...state.asset._notes, payload] },
});

export const removeAssetNote = (state, { payload }) => ({
  ...state,
  asset: {
    ...state.asset,
    _notes: state.asset._notes
      .map((note) => (note.id === payload ? { ...note, deleted: true } : note))
      .filter((note) => !note.deleted || note.createdAt),
  },
});

export const modifyAssetNote = (state, { payload }) => ({
  ...state,
  asset: {
    ...state.asset,
    _notes: state.asset._notes.map((note) =>
      note.id === payload.id ? { ...note, text: payload.text } : note
    ),
  },
});

export const modifyFile = (state, { payload: { fileId, payload } }) => ({
  ...state,
  asset: {
    ...state.asset,
    _files: state.asset._files.map((file) =>
      file.id === fileId ? { ...file, ...payload } : { ...file, default: false }
    ),
  },
});

//Groups
export const modifyCustomField = (state, { payload }) => {
  const newCustoms = findAndModify(state.asset._custom, payload);
  return {
    ...state,
    asset: {
      ...state.asset,
      ...payload,
      _custom: newCustoms,
    },
  };
};

export const findAndModify = (_custom, payload) => {
  const keys = Object.getOwnPropertyNames(payload);
  const key = keys[0];
  const value = payload[key];
  let banderaExiste = false;
  let newCustoms = [..._custom] || [];

  newCustoms.forEach((element) => {
    if (element.key == key) {
      // Edit custom
      element.value = value;
      banderaExiste = true;
    }
  });

  if (!banderaExiste) newCustoms.push({ key, value }); // Add custom
  return newCustoms;
};
//Groups

const formReducers = {
  [MODIFY_ASSET]: modifyAsset,
  [NEW_ASSET]: newAsset,
  [GET_ASSETS_FORM_CONFIG]: {
    [PENDING]: getPending,
    [REJECTED]: getRejected,
    [FULFILLED]: getFulfilled,
  },
  [GET_ASSETS_DISABLE_FORM_CONFIG]: {
    [PENDING]: getPending,
    [REJECTED]: getRejected,
    [FULFILLED]: getFulfilled,
  },
  [GET_ASSET_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [RESET_ASSETS_FORM]: resetForm,
  [CALCULATE_ASSET_DEPRECIATION]: calculateDepreciation,
  [ADD_ASSETS_FILES]: addAssetsFiles,
  [REMOVE_ASSETS_FILE]: removeAssetsFile,
  [PROGRESS_ASSETS_FILE]: progressAssetsFile,
  [UPLOAD_ASSETS_FILE]: {
    [PENDING]: uploadFilePending,
    [REJECTED]: uploadFileRejected,
    [FULFILLED]: uploadFileFulfilled,
  },
  [SET_ASSETS_IS_SAVING]: setIsSaving,
  [ADD_ASSET]: {
    [PENDING]: addPending,
    [REJECTED]: addRejected,
    [FULFILLED]: addFulfilled,
  },
  [OUTPUT_ASSET]: {
    [PENDING]: in_outPending,
    [REJECTED]: in_outRejected,
    [FULFILLED]: in_outFulfilled,
  },
  [INPUT_ASSET]: {
    [PENDING]: in_outPending,
    [REJECTED]: in_outRejected,
    [FULFILLED]: in_outFulfilled,
  },
  [ACEPT_OUTPUT]: {
    [PENDING]: in_outPending,
    [REJECTED]: in_outRejected,
    [FULFILLED]: in_outFulfilled,
  },
  [REJECT_OUTPUT]: {
    [PENDING]: in_outPending,
    [REJECTED]: in_outRejected,
    [FULFILLED]: in_outFulfilled,
  },
  [REMOVE_ASSETS_UPLOADED_FILE]: removeAssetsUploadedFile,
  [ADD_ASSET_NOTE]: addAssetNote,
  [REMOVE_ASSET_NOTE]: removeAssetNote,
  [MODIFY_ASSET_NOTE]: modifyAssetNote,
  [MODIFY_CUSTOM_FIELD_EDITING_ASSET]: modifyCustomField, //Groups
  [MODIFY_FILE]: modifyFile,
};

export default TypeToReducer(formReducers, initialState);



// WEBPACK FOOTER //
// src/containers/assets/reducers_form.js